import { gql } from 'apollo-angular';

export const saveOperationPoint = 'saveOperationPoint';
export const saveOperationPointMutation = gql`
  mutation SaveOperationPoint($operationPoint: OperationPointInput!) {
    saveOperationPoint(operationPoint: $operationPoint) {
      id
    }
  }
`;
